const Feature = {
	MARITIME: {
		BOUNDARIES: {
			VIEW: "maritime.boundaries.view"
		},
		NAUTICAL_CHARTS: {
			VIEW: "maritime.nautical_charts.view"
		},
		ENHANCED_VESSEL_DATA: {
			VIEW: "maritime.enhanced_vessel_data.view"
		},
		HOTSPOTS: {
			STS: {
				VIEW: "maritime.hotspots.sts.view"
			}
		},
		UKHO: {
			FEATURES: {
				VIEW: "maritime.ukho.features.view"
			}
		},
		PORTS: {
			STATS: {
				VIEW: "maritime.ports.stats.view"
			}
		},
		MISS: {
			VIEW: "maritime.miss.view"
		},
		SHIPPING_LANE_ROUTING: {
			VIEW: "maritime.shipping_lane_routing.view"
		},
		VESSEL_COMMENTS: {
			VIEW: "maritime.vessel_comments.view",
			EDIT: "maritime.vessel_comments.edit"
		},
		MARMANS: {
			VIEW: "maritime.marmans.view"
		},
		RISKINTELLIGENCE: {
			INCIDENTS: {
				VIEW: "maritime.riskintelligence.incidents.view"
			},
			PORTS: {
				VIEW: "maritime.riskintelligence.ports.view"
			}
		},
		NATIONALGRID: {
			UNDERSEA_CABLES: {
				VIEW: "maritime.nationalgrid.undersea_cables.view"
			}
		},
		OFFSHORE_INFRASTRUCTURE: {
			VIEW: "maritime.offshore_infrastructure.view"
		}
	},
	ALERTS: {
		VIEW: "alerts.view",
		FILTER: "alerts.filter",
		DOWNLOAD: "alerts.download"
	},
	VESSEL_HISTORY: {
		VIEW: "vessel_history.view",
		SEARCH_BY_MMSI: "vessel_history.search_by_mmsi",
		INVESTIGATE: "vessel_history.investigate",
		RESTRICTED_INPUTS: "vessel_history.restricted_inputs"
	},
	VESSELS_NEARBY: {
		VIEW: "vessels_nearby.view"
	},
	ENVIRONMENT: {
		HISTORY: {
			TWO_YEARS: "environment.history.two_years"
		},
		ALTITUDINAL_DATA: {
			VIEW: "environment.altitudinal_data.view"
		},
		VIEW: "environment.view"
	},
	HURRICANES: {
		VIEW: "hurricanes.view"
	},
	VOLCANOES: {
		VIEW: "volcanoes.view"
	},
	EARTHQUAKES: {
		VIEW: "earthquakes.view"
	},
	FLOODS: {
		VIEW: "floods.view"
	},
	PORT_ASSESSMENTS: {
		VIEW: "port_assessments.view"
	},
	SATELLITE_IMAGERY: {
		VIEW: "satellite_imagery.view"
	},
	TIME_SLIDER: {
		VIEW: "time_slider.view"
	},
	GRAPHS: {
		VIEW: "graphs.view"
	},
	SANCTIONS: {
		VIEW: "sanctions.view"
	},
	SHIPPING_LANES: {
		VIEW: "shipping_lanes.view",
		FISHING: {
			VIEW: "shipping_lanes.fishing.view"
		},
		FISHING_TRAWLERS: {
			VIEW: "shipping_lanes.fishingtrawlers.view"
		},
		DARK: {
			VIEW: "shipping_lanes.dark.view"
		}
	},
	TIMEZONES: {
		VIEW: "timezones.view"
	},
	IMAGE_ASSETS: {
		VIEW: "image_assets.view",
		EDIT: "image_assets.edit"
	},
	ANNOTATIONS: {
		VIEW: "annotations.view"
	},
	NOTEPAD: {
		VIEW: "notepad.view",
		EDIT: "notepad.edit"
	},
	MEASURE: {
		VIEW: "measure.view"
	},
	SAR_DVD: {
		VIEW: "sar_dvd.view"
	},
	SATELLITE_RFD: {
		VIEW: "satellite_rfd.view"
	},
	AVIATION: {
		ALERTS: {
			VIEW: "aviation.alerts.view"
		},
		DUMMY_DATA: {
			VIEW: "aviation.dummy_data.view"
		},
		NOTAMS: {
			VIEW: "aviation.notams.view"
		},
		AIRCRAFT_HISTORY: {
			VIEW: "aviation.aircraft_history.view"
		},
		VIEW: "aviation.view"
	},
	COMPANY: {
		VIEW: "company.view",
		EDIT: "company.edit"
	},
	ADMIN: {
		VIEW: "admin.view", // Can view/open the CMS. Tabs available dependent on permissions.
		EDIT: "admin.edit", // All edit permissions!
		USERS: {
			VIEW: "admin.users.view",
			EDIT: "admin.users.edit"
		},
		COMPANIES: {
			VIEW: "admin.companies.view",
			EDIT: "admin.companies.edit"
		},
		TIERS: {
			VIEW: "admin.tiers.view",
			EDIT: "admin.tiers.edit"
		},
		ROIS: {
			VIEW: "admin.rois.view",
			EDIT: "admin.rois.edit"
		},
		IMAGES: {
			VIEW: "admin.images.view",
			EDIT: "admin.images.edit"
		},
		COMMENTS: {
			VIEW: "admin.comments.view",
			EDIT: "admin.comments.edit"
		}
	}
};

// TODO: Same issue here as AlertType enum. Not sure how to process/where to put. Should there be helpers?
Feature.all = () => {
	const recursiveGetKeys = (start) => {
		return Object.keys(start).map((key) => {
			if (typeof start[key] === "object") {
				return recursiveGetKeys(start[key]);
			}
			return start[key];
		});
	};
	const recursiveFlatten = (start) => {
		let all = [];
		if (typeof start === "string") {
			all.push(start);
		}
		else if (typeof start === "object" && start.length > 0) {
			for (let i = 0; i < start.length; i++) {
				all = [
					...recursiveFlatten(start[i]),
					...all
				];
			}
		}
		return all;
	};

	const keysTree = recursiveGetKeys(Feature);
	const flatValues = recursiveFlatten(keysTree);

	return flatValues;
};
Feature.all();

Feature.processKeyedFeaturesIntoArray = (keyedFeatures) => {
	const featuresArray = Object.keys(keyedFeatures).filter((key) => {
		return keyedFeatures[key] > 0;
	});
	return featuresArray;
};

export default Feature;
